import { httpsCallable } from 'firebase/functions';
import { functions } from '../../utils/firebase.config';

export enum EmailTemplate {
  SplitPayment = 'SplitPayment',
  Notification = 'Notification',
}

interface SendEmailInput {
  to: string[];
  template: EmailTemplate;
  data: Record<string, any>;
}

export const useEmails = () => {
  const sendEmail = async (input: SendEmailInput): Promise<void> => {
    const callable = httpsCallable<SendEmailInput, void>(functions, 'sendEmail');

    await callable(input);
  };

  return { sendEmail };
};

export default useEmails;
